import { render, staticRenderFns } from "./CouponSubmitSuccessModal.vue?vue&type=template&id=2457cd66&scoped=true&"
import script from "./CouponSubmitSuccessModal.vue?vue&type=script&lang=js&"
export * from "./CouponSubmitSuccessModal.vue?vue&type=script&lang=js&"
import style0 from "./CouponSubmitSuccessModal.vue?vue&type=style&index=0&id=2457cd66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2457cd66",
  null
  
)

export default component.exports